// NATIVE 
import React, { useEffect, useState } from 'react';


// INSTALLED 
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Grid, TextField } from '@mui/material';
import TextAreaField from '../../formFields/TextAreaField';
import AutocompleteField from '../../formFields/autocompleteField';


// CUSTOM 
import InputField from '../../formFields/InputField';
import CheckboxField from '../../formFields/checkBoxField';
import InputNumeric from '../../formFields/InputNumeric';





export const CreateParameter = (props:any) => {



    const { formField: {
        llegadas_tarde,
        salidas_tarde,
        salario_minimo,
        auxilio_transporte,
        interes_cesantias,
        year,
        horasSemanales,
        horasMensuales
      }
    } = props;


            


    const Div = styled('div')(({ theme }) => ({
        ...theme.typography.button,
        backgroundColor: 'wheat',
        padding: theme.spacing(8),
        textAlign: 'center'
    }));


    
    
  return (
    <div>
        
        <div>
            <Grid container>
                <Grid size={{ xs: 6}} sx={{ padding: 2 }}>
                    <InputNumeric
                        name={year.name}
                        label={year.label}
                        variant="outlined" 
                        fullWidth
                    />
                </Grid>
                <Grid size={{ xs: 6}} sx={{ padding: 2 }}>
                    <InputNumeric 
                        name={interes_cesantias.name}
                        label={interes_cesantias.label}
                        variant="outlined" 
                        fullWidth
                    />
                </Grid>

                <Grid size={{ xs: 6}} sx={{ padding: 2 }}>
                    <InputNumeric 
                        name={llegadas_tarde.name}
                        label={llegadas_tarde.label}
                        variant="outlined" 
                        fullWidth
                    />
                </Grid>
                
                <Grid size={{ xs: 6}} sx={{ padding: 2 }}>
                    <InputNumeric 
                        name={salidas_tarde.name}
                        label={salidas_tarde.label}
                        variant="outlined" 
                        fullWidth
                    />
                </Grid>

                <Grid size={{ xs: 6}} sx={{ padding: 2 }}>
                    <InputNumeric 
                        name={salario_minimo.name}
                        label={salario_minimo.label}
                        variant="outlined" 
                        fullWidth
                    />
                </Grid>
                <Grid size={{ xs: 6}} sx={{ padding: 2 }}>
                    <InputNumeric 
                        name={auxilio_transporte.name}
                        label={auxilio_transporte.label}
                        variant="outlined" 
                        fullWidth
                    />
                </Grid>
                <Grid size={{ xs: 6}} sx={{ padding: 2 }}>
                    <InputNumeric 
                        name={horasSemanales.name}
                        label={horasSemanales.label}
                        variant="outlined" 
                        fullWidth
                    />
                </Grid>
                <Grid size={{ xs: 6}} sx={{ padding: 2 }}>
                    <InputNumeric 
                        name={horasMensuales.name}
                        label={horasMensuales.label}
                        variant="outlined" 
                        fullWidth
                    />
                </Grid>
                
                    

            </Grid>
        </div>
        
    </div>
  )
}

